import { render, staticRenderFns } from "./item_color.vue?vue&type=template&id=2c5a2c8e&scoped=true&lang=pug&"
import script from "./item_color.vue?vue&type=script&lang=js&"
export * from "./item_color.vue?vue&type=script&lang=js&"
import style0 from "./item_color.vue?vue&type=style&index=0&id=2c5a2c8e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5a2c8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2c5a2c8e', component.options)
    } else {
      api.reload('2c5a2c8e', component.options)
    }
    module.hot.accept("./item_color.vue?vue&type=template&id=2c5a2c8e&scoped=true&lang=pug&", function () {
      api.rerender('2c5a2c8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/design_token/item_color.vue"
export default component.exports